const Eyebrow = ({ children, className = "", color = "default" }) => {
  const tones = {
    default: "text-ecospora-green-mid",
    ochre: "text-ecospora-ochre",
    cream: "text-ecospora-ochre",
    soft: "text-ecospora-green-soft",
  };
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <span className={`w-8 h-px ${tones[color] === "text-ecospora-ochre" ? "bg-ecospora-ochre" : "bg-ecospora-green-mid"}`} />
      <span className={`text-[11px] font-semibold tracking-[0.22em] uppercase ${tones[color] || tones.default}`}>
        {children}
      </span>
    </div>
  );
};

export default Eyebrow;
